<div class="back-btn"><span class="material-icons">keyboard_arrow_left</span> <a routerLink="/login"
    class="back-btn" data-testid="forgot-back-to-login-link">Return To
    Login</a></div>
<div class="login-container">

  <form [formGroup]="forgotPassword">

    <a routerLink="/invitations" data-testid="forgot-logo-link"><img class="login-logo" src="../../assets/img/logo.png" alt="logo"></a>

    <div class="title">Forgot password</div>
    <hr />
    <div class="sm-text">Enter your email address and we'll email you a link to reset your password.</div>
    <input id="email" type="email" class="input" placeholder="Email" formControlName="email" maxlength="100"
      autocomplete="disabled" data-testid="forgot-email" />
    <div
      *ngIf="forgotPassword.controls['email']?.invalid && (forgotPassword.controls['email'].dirty || forgotPassword.controls['email'].touched)">
      <div *ngIf="forgotPassword.controls['email'].errors?.['required']" class="error-message">
        Email is required.
      </div>
      <div
        *ngIf="forgotPassword.controls['email'].value!='' && !forgotPassword.controls['email'].value?.match(emailRegx)"
        class="error-message">
        Please enter a valid email.
      </div>
    </div>
    <hr />
    <div class="panel-fields">
      <button type="submit" class="btn btn-default w-25" (click)="cancel()" data-testid="forgot-cancel">Cancel</button>
      <button type="submit" class="btn btn-primary" (click)="password()" [disabled]="isSubmitting" data-testid="forgot-submit">Forgot Password</button>
    </div>
  </form>
</div>